import { createFileRoute } from "@tanstack/react-router";
import { CompareHub } from "./jamfor.index";

const TITLE = "Compare sites for selling second hand | Sellavo";
const DESCRIPTION =
  "Blocket, Tradera, Facebook Marketplace or Sellpy? Compare how the services work and when Sellavo fits better.";

export const Route = createFileRoute("/en/compare")({
  loader: async () => {
    const { COMPARISONS } = await import("@/lib/jamforelser");
    return {
      items: COMPARISONS.map((c) => ({ slug: c.slug, h1: c.h1, description: c.description })),
    };
  },
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESCRIPTION },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESCRIPTION },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://sellavo.com/en/compare" }],
  }),
  component: CompareHub,
});
